import Field from '/src/components/UI/Field/Field';
import TextInput from '/src/components/UI/TextField/TextInput';
import Dropdown from '../../../../components/UI/DropDown/DropDown';
import ButtonAction from "/src/components/UI/Button/Button";
import NiceModal from '@ebay/nice-modal-react';
import ApiModal from '/src/components/modal/ApiModal/ApiModal';
import LogoutModal from '/src/features/auth/components/LogoutModal/LogoutModal'
import ChangePasswordModal from '../ChangePasswordModal/ChangePasswordModal';
import "./AccountInformation.css"
import "/src/assets/css/polices.css";
import { useNavigate } from 'react-router-dom';
import ImageUser from '../ImageUser/ImageUser';
import accountService from '../../services/accountService';
import { useAuthStateContext } from '/src/features/auth/context/authContext';
import { useEffect, useState } from 'react';
import { useAuthDispatchContext } from '/src/features/auth/context/authContext';
import userAction from "/src/features/user/actions/userAction";
import storage from '/src/utils/storage';
import { useAuthDispatchContext } from '/src/features/auth/context/authContext';
import { removeStorageParamForCurrentCompany } from '/src/utils/storageParamForCurrentCompany';
import hasPermission from '/src/utils/hasPermission';
function AccountInformation() {

    const navigate = useNavigate();
    const currentCompany = storage("session").get("company");
    const [companies, setCompanies] = useState([]);
    const { user } = useAuthStateContext();
    const dispatch = useAuthDispatchContext();
    

    const { getInformationUser } = accountService;
    const { changeCompany } = userAction;
    const showLogoutModal = () => NiceModal.show(LogoutModal).then(() => {
        removeStorageParamForCurrentCompany('conversation_filters');
        sessionStorage.removeItem('user');
        localStorage.removeItem('token');
        dispatch({ type: 'loginOut' });
        navigate('/login')
    })
    const showChangePasswordModal = () => NiceModal.show(ChangePasswordModal)
    const logout =
        <>
            <span>Logout</span>
            <div className='svg logout'></div>
        </>

    const onClickDeleteAccount = async () => {
        //const { id, name } = row;


        await NiceModal.show(ApiModal, {
            title: 'Delete Account ' + user.username,
            body: 'Do you really want to delete your account ' + user.username,
            /* // PAS ENCORE FONCTIONNEL
            api: {
                request: deleteChannel,
                param: [id, name]
            },
            */
            buttons: [
                { className: 'validate', label: 'Cancel' },
                { className: 'cancel', label: 'Delete', type: 'submit' },
            ],
            confirm: {
                name: user.username,
                fieldName: "your account",
            }
        });
    };

    const updateCompany = async (company_id) => {
        const res = await changeCompany(company_id);
        if (res.error != null) {
            return;
        }
        const { user, company } = res
        dispatch({type : 'refreshUserInfo', payload : {user, token : storage('local').get('token')}});
    }
    const getCompaniesListUser = async () => {
        var [response, error] = await getInformationUser();
        if (error != null) {
            console.log(error);
            return;
        }
        setCompanies(setUpCompanies(response.user.companies));
    }

    const setUpCompanies = (_companies) => {
        _companies = _companies.sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? - 1 : 1)
        let res = _companies.map(company => {
            return {
                value: company.id,
                text: <span style={{ maxWidth: "300px", justifyContent: "start" }}> <img src={company.logo} /> <div className="dashboard_content_dropdown"> {company.name} </div> </span>
            }
        })
        return res
    };
    useEffect(() => {
        if (hasPermission('change_company')) {
            getCompaniesListUser();
        } else {
            setCompanies([{ value: currentCompany.id, text: currentCompany.name }]);
        }
    }, []);
    return (
        <>
            <div className="account-bar">
                <Field label="My Account" listClassName="title-user-section" listLabelClassName="title-section" />
                {!user?.external_id && (
                    <div onClick={showLogoutModal}>
                        <ButtonAction label={logout} />
                    </div>
                )}
            </div>
            <div className='user-form'>
                <ImageUser id={user.id} image={user.picture} />
                <div className="informations-section">
                    <Field label="Username" listClassName="title-user-section" listLabelClassName=" title-weigth" />
                    <TextInput value={user.username} className="max-width" style={{ width: '100%' }} disabled />
                    <br /><br />
                    <Field label="Email" listClassName="title-user-section" listLabelClassName=" title-weigth" />
                    <TextInput value={user.email} className="max-width" style={{ width: '100%' }} disabled />
                    <br /><br />
                    <div className="company-section">
                        <Field label="Organizations" listClassName="title-user-section" listLabelClassName=" title-weigth" />
                        {companies.length > 0 && <Dropdown choices={companies} width="210px" setValue={(name, value) => { updateCompany(value) }} defaultChoice={currentCompany.id} />}
                        <br /><br />
                    </div>
                    <br />

                    <Field label="Registered" listClassName="title-user-section" listLabelClassName=" title-weigth" />
                    <Field listLabelClassName="date-registered" label="Since Monday 22 August 2022" />
                    <br />
                    <div className="other-section">
                        <Field label="Datas" listClassName="title-user-section" listLabelClassName=" title-weigth" />
                        <div className="section-actions">
                            <Field label="Download my data" listLabelClassName="discret" />
                        </div>
                    </div>
                    <div className="tokenTalkr-section">
                        <Field label="Token Talkr" listClassName="title-user-section" listLabelClassName=" title-weigth" />
                        <div className="section-actions">
                            <Field label="" listLabelClassName="discret" />
                        </div>
                    </div>
                    <div className="user-part">
                        <Field label="Security" listClassName="title-user-section" listLabelClassName="title-weigth" />
                        <div className="section-actions">
                           {(hasPermission('change_password') && !user?.external_id) && (
                             <div onClick={showChangePasswordModal}>
                             <Field label="Change your password" listLabelClassName="discret blue-discret" />
                            </div>
                           )}
                            {hasPermission('delete_account') && (
                                <div onClick={onClickDeleteAccount}>
                                    <Field label="Delete Account" listLabelClassName="discret red-discret" />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>


    )
}

export default AccountInformation